import * as ng from 'angular';
import { TypeaheadFocus } from './typehead-focus.directive';


export const TypeaheadFocusModule: string =
    ng.module('typehead-focus', [
    ])
        .directive('typeaheadFocus', TypeaheadFocus)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/typeahead-focus/typehead-focus.module.ts